<template>
  <div>
    <h1>スポーツ施設 休日空き状況</h1>
    <p>東京都、神奈川県、江東区、練馬区、大田区、江戸川区の公共のスポーツ施設の土日、祝日の空き情報を発信しています。</p>
    <br />
    <div class="events">
      <div>
        <h2>テニス</h2>
        <ul>
          <li>
            <router-link :to="{name:'summary', params:{city:'tokyo', event:'tennis' }}">東京都 テニス</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'kanagawa', event:'tennis' }}">神奈川県 テニス</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'koto', event:'tennis' }}">江東区 テニス</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'nerima', event:'tennis' }}">練馬区 テニス</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'ota', event:'tennis' }}">太田区 テニス</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'edogawa', event:'tennis' }}">江戸川区 テニス</router-link>
          </li>
        </ul>
      </div>
      <div>
        <h2>サッカー</h2>
        <ul>
          <li>
            <router-link :to="{name:'summary', params:{city:'tokyo', event:'soccer' }}">東京都 サッカー</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'koto', event:'soccer' }}">江東区 サッカー</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'nerima', event:'soccer' }}">練馬区 サッカー</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'ota', event:'soccer' }}">太田区 サッカー</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'edogawa', event:'soccer' }}">江戸川区 サッカー</router-link>
          </li>
        </ul>
      </div>
      <div>
        <h2>野球</h2>
        <ul>
          <li>
            <router-link :to="{name:'summary', params:{city:'tokyo', event:'baseball' }}">東京都 野球</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'kanagawa', event:'baseball' }}">神奈川県 野球</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'koto', event:'baseball' }}">江東区 野球</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'nerima', event:'baseball' }}">練馬区 野球</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'ota', event:'baseball' }}">太田区 野球</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'edogawa', event:'baseball' }}">江戸川区 野球</router-link>
          </li>
        </ul>
      </div>
      <div>
        <h2>屋内施設</h2>
        <ul>
          <li>
            <router-link :to="{name:'summary', params:{city:'koto', event:'indoor' }}">江東区 屋内施設</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'nerima', event:'indoor' }}">練馬区 屋内施設</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'ota', event:'indoor' }}">太田区 屋内施設</router-link>
          </li>
          <li>
            <router-link :to="{name:'summary', params:{city:'edogawa', event:'indoor' }}">江戸川区 屋内施設</router-link>
          </li>
        </ul>
        <div>※バドミントン、バレーボール、バスケットボール、フットサル、卓球など</div>
      </div>
    </div>
    <div>
      <a
        class="twitter-timeline"
        data-width="400"
        data-height="250"
        data-theme="dark"
        data-lang="ja"
        href="https://twitter.com/sports_yoyaku?ref_src=twsrc%5Etfw"
      >Tweets by sports_yoyaku</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Top",
  mounted: function() {
    document.title = "スポーツ施設|休日空き情報";
    document
      .querySelector("meta[name='description']")
      .setAttribute(
        "content",
        "東京都、神奈川県、江東区、練馬区、大田区、江戸川区の公共のスポーツ施設の土日、祝日の休日空き情報を分かりやすく発信しています。テニスコート、野球場、サッカーコート、バドミントン、バレーボール、バスケットボール、フットサル、卓球など"
      );
  }
};
</script>

<style scoped>
li {
  list-style: none;
}

@media screen and (min-width: 1000px) {
  /* 画面サイズ 1000px以上から適用 */
  .events {
    margin: 0px 200px;
    /* padding: 0px 200px; */
    height: 200px;
  }

  .events > div {
    width: 25%;
    float: left;
    /* box-sizing: border-box; */
  }
}
</style>